import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClick())),
    "data-cy": _ctx.dataCyId + '_Click',
    "no-gutters": "",
    class: _normalizeClass(["pa-3 fill-height rounded-xl bg-primary-foreground", [_ctx.borderClass, _ctx.cursorPointerClass]])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "2",
        class: _normalizeClass(["d-flex align-center justify-center", _ctx.borderRightClass])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { color: "red" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" $fa-exclamation-triangle ")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_col, {
        cols: "10",
        class: "d-flex align-center pl-2",
        "data-cy": _ctx.dataCyId + '_Message'
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.message), 1)
        ]),
        _: 1
      }, 8, ["data-cy"])
    ]),
    _: 1
  }, 8, ["data-cy", "class"]))
}